export default __webpack_public_path__ + "img/fACUmBRW.596e2799.svg";